module.exports = "<span class='main'\n    *ngIf='rts.currentProject && tag && isSelected'>\n        {{tag.title}}\n</span>\n"


//////////////////
// WEBPACK FOOTER
// /GIT/Search-manager/rating-module/src/app/tag-button/tag-button.component.html
// module id = ../../../../../src/app/tag-button/tag-button.component.html
// module chunks = main